<template>
    <div class="dateLeft" id="navleft">
            <dl>
                <dt class="forecast"><router-link tag="a" to="/forecast/production">预测数据</router-link></dt>
                <dd>
                    <router-link tag="a" to="/forecast/production">产量</router-link>
                    <router-link tag="a" to="/forecast/sales">销量</router-link>
                </dd>
            </dl>
            <dl>
                <dt class="map"><router-link tag="a" to="/map/production">分布地图</router-link></dt>
                <dd>
                    <router-link tag="a" to="/map/production">产量</router-link>
                    <router-link tag="a" to="/map/capacity">产能</router-link>
                </dd>
            </dl>
            <dl>
                <dt class="charts"><router-link tag="a" to="/rank/production">排行榜</router-link></dt>
                <dd>
                    <router-link tag="a" to="/rank/production">产量</router-link>
                    <router-link tag="a" to="/rank/sales">销量</router-link>
                </dd>
            </dl>
            <dl>
                <dt class="reckon"><router-link tag="a" to="/calculate">产值计算</router-link></dt>
                <dd>
                    <router-link tag="a" to="/calculate">产值</router-link>
                </dd>
            </dl>
        </div>
</template>

<script>
export default {
    name: 'app-left-sidebar'
}
</script>